import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'

const AnimationSelector = props =>
  <FormControl component="fieldset">
    <FormLabel component="legend">Animation</FormLabel>
    <RadioGroup aria-label="animation" name="animation" value={props.value} onChange={props.onChange}>
      <FormControlLabel value="none" control={<Radio />} label="None" />
      <FormControlLabel value="rotate" control={<Radio />} label="Rotate" />
      <FormControlLabel value="shake" control={<Radio />} label="Shake" />
      <FormControlLabel value="beat" control={<Radio />} label="Beat" />
    </RadioGroup>
  </FormControl>

export default AnimationSelector